import { useEffect, useState } from "react";
import { useApp } from "../hooks/AppProvider";
import '../css/home.css';

function Home() {
    let app = useApp();
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {                        
            setTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
        <div className="home-main">
            <h1 className="home-title">Bienvenue <i>{app.tokenPayload().display_name}</i></h1>
            <h3>Nous sommes le {time.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}, il est {time.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit", hour12: false })}</h3>
            <br />
            <hr />
            <img className="home-logo" src="/img/logo_text_black_512.png" />
        </div>
        </>
    );
}

export default Home;